import checkTenantGetReducer from "./api/checkTenantGet/checkTenantGetReducer";
import usersMeGetReducer from "./api/usersMeGet/usersMeGetReducer";
import rootAccountGetReducer from "./api/rootAccountGet/rootAccountGetReducer";
import applicationConnectPostReducer from "./api/applicationConnectPost/applicationConnectPostReducer";

import notificationsGetReducer from "./api/notificationsGet/notificationsGetReducer";
import notificationHidePutReducer from "./api/notificationHidePut/notificationHidePutReducer";
import notificationTouchPutReducer from "./api/notificationTouchPut/notificationTouchPutReducer";
import notificationsTouchAllPutReducer from "./api/notificationsTouchAllPut/notificationsTouchAllPutReducer";

import currentChildOrganizationReducer from "./domain/currentChildOrganization/currentChildOrganizationReducer";
import saasIntegrationReducer from "./domain/saasIntegration/saasIntegrationReducer";

import whitelabelGetReducer from "store/whitelabel/whitelabelGetReducer";
import uiPopupsPostReducer from "store/api/uiPopupsPost/uiPopupsPostReducer";
import accountGetReducer from "store/api/organization/accountGet/accountGetReducer";
import subscriptionActivateAddonsPostReducer from "store/api/organization/subscriptionActivateAddonsPost/subscriptionActivateAddonsPostReducer";
import agentsBuildsGetReducer from "store/api/organization/agentsBuildsGet/agentsBuildsGetReducer";
import getStartedProgressGetReducer from "store/api/organization/getStartedProgressGet/getStartedProgressGetReducer";
import getStartedRefreshReducer from "store/api/organization/getStartedRefresh/getStartedRefreshReducer";
import cpCheckTenantGetReducer from "./api/cpCheckTenantGet/cpCheckTenantGetReducer";
import cpCheckTenantSKUsGetReducer from "./api/cpCheckTenantSKUs/cpCheckTenantSKUsGetReducer";
import cpAppEvalSKUsPostReducer from "./api/cpAppEvalSKUsPost/cpAppEvalSKUsPostReducer";
import organizationsGetReducer from "./api/organizationsGet/organizationsGetReducer";
import networkPoliciesGetReducer from "store/api/organization/networkPoliciesGet/networkPoliciesGetReducer";
import dpcProfilesGetReducer from "store/api/organization/dpcProfilesGet/dpcProfilesGetReducer";
import applicationsSettingsGetReducer from "store/api/organization/applicationsSettingsGet/applicationsSettingsGetReducer";
// Slices that the Network MFE needs always-on. Pre-MFE these were lazy-injected
// by per-route index.js modules (MonitorLogs/ActiveSessions, NetworkAccess/*).
// Registering them globally is simpler than exposing reducer/saga pairs through
// MF — exposing those creates separate lazy chunks and triggers TDZ when host's
// rootSaga.fork() reads `default` from a saga whose module is mid-evaluation.
import applicationsGetReducer from "store/api/organization/applicationsGet/applicationsGetReducer";
import networksGetReducer from "store/api/organization/networksGet/networksGetReducer";
import networksBeaconsGetReducer from "store/api/organization/networksBeaconsGet/networksBeaconsGetReducer";
import networkBeaconDeleteReducer from "store/api/organization/networkBeaconDelete/networkBeaconDeleteReducer";
import sslCertificatesGetReducer from "store/api/organization/sslCertificatesGet/sslCertificatesGetReducer";
import signedUrlPostReducer from "store/api/signedUrlPost/signedUrlPostReducer";
import webRulesSWGGetReducer from "store/api/organization/webRulesSWGGet/webRulesSWGGetReducer";
import policyInsightsConflictsGetReducer from "store/api/organization/policyInsightsConflictsGet/policyInsightsConflictsGetReducer";
import policyInsightsConflictAckPatchReducer from "store/api/organization/policyInsightsConflictAckPatch/policyInsightsConflictAckPatchReducer";
import threatPreventionProfilesGetReducer from "store/api/organization/threatPreventionProfilesGet/threatPreventionProfilesGetReducer";
import updatableObjectsReducer from "./api/updatableObjects/updatableObjectsReducer";
import ipsecVendorsGetReducer from "./api/organization/ipsecVendorsGet/ipsecVendorsGetReducer";
import permissionCategoriesGetReducer from "./api/permissionCategoriesGet/permissionCategoriesGetReducer";
import servicesGetReducer from "./api/organization/servicesGet/servicesGetReducer";
// regionsGet is read by MFE-owned Create/Edit Network + CreateRegions/
// CreateGateways/ManageScaleUnits flows. Host's own routes lazy-inject it
// via their index.js, but MFE bypasses those host routes, so we register
// globally here — idempotent with the lazy injections that stay in place
// as the fallback path when `ffKey.use.network.mfe` is off.
import regionsGetReducer from "./api/regionsGet/regionsGetReducer";
// membersAllGet + groupsGet + webCategoriesGet + addressesGet are read by
// RuleTarget and FilterBlock inside Security routes (bypass, web-filter,
// tenant-restrictions, threat-prevention, DLP). Monolith route wrappers
// lazy-inject them, but the IA MFE bypasses those wrappers, so we register
// globally here for Session 5.
import membersAllGetReducer from "./api/organization/membersAllGet/membersAllGetReducer";
import groupsGetReducer from "./api/organization/groupsGet/groupsGetReducer";
import webCategoriesGetReducer from "./api/organization/webCategoriesGet/webCategoriesGetReducer";
import addressesGetReducer from "./api/organization/addressesGet/addressesGetReducer";

export default {
  checkTenantGet: checkTenantGetReducer,
  cpCheckTenantSKUsGet: cpCheckTenantSKUsGetReducer,
  cpCheckTenantGet: cpCheckTenantGetReducer,
  cpAppEvalSKUsPost: cpAppEvalSKUsPostReducer,
  usersMeGet: usersMeGetReducer,
  rootAccountGet: rootAccountGetReducer,
  applicationConnectPost: applicationConnectPostReducer,
  notificationsGet: notificationsGetReducer,
  notificationHidePut: notificationHidePutReducer,
  notificationTouchPut: notificationTouchPutReducer,
  notificationsTouchAllPut: notificationsTouchAllPutReducer,
  currentChildOrganization: currentChildOrganizationReducer,
  saasIntegration: saasIntegrationReducer,
  whitelabelGet: whitelabelGetReducer,
  uiPopupsPost: uiPopupsPostReducer,
  accountGet: accountGetReducer,
  subscriptionActivateAddonsPost: subscriptionActivateAddonsPostReducer,
  agentsBuildsGet: agentsBuildsGetReducer,
  getStartedProgressGet: getStartedProgressGetReducer,
  getStartedRefresh: getStartedRefreshReducer,
  organizationsGet: organizationsGetReducer,
  networkPoliciesGet: networkPoliciesGetReducer,
  dpcProfilesGet: dpcProfilesGetReducer,
  applicationsSettingsGet: applicationsSettingsGetReducer,
  applicationsGet: applicationsGetReducer,
  networksGet: networksGetReducer,
  networksBeaconsGet: networksBeaconsGetReducer,
  networkBeaconDelete: networkBeaconDeleteReducer,
  sslCertificatesGet: sslCertificatesGetReducer,
  signedUrlPostReducer: signedUrlPostReducer,
  webRulesSWGGet: webRulesSWGGetReducer,
  policyInsightsConflictsGet: policyInsightsConflictsGetReducer,
  policyInsightsConflictAckPatch: policyInsightsConflictAckPatchReducer,
  threatPreventionProfilesGet: threatPreventionProfilesGetReducer,
  updatableObjects: updatableObjectsReducer,
  ipsecVendorsGet: ipsecVendorsGetReducer,
  permissionCategoriesGet: permissionCategoriesGetReducer,
  servicesGet: servicesGetReducer,
  regionsGet: regionsGetReducer,
  membersAllGet: membersAllGetReducer,
  groupsGet: groupsGetReducer,
  webCategoriesGet: webCategoriesGetReducer,
  addressesGet: addressesGetReducer,
};
